import { createSlice } from "@reduxjs/toolkit";
import deleteUrgencyApi from "@custom/rtk-apis/billing/urgency/deleteUrgency";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const deleteUrgencySlice = createSlice({
  name: "deleteUrgencySlice",
  initialState,
  reducers: {
    clearDeleteUrgency: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteUrgencyApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteUrgencyApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deleteUrgencyApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deleteUrgencySlice.reducer;
export const { clearDeleteUrgency } = deleteUrgencySlice.actions;
